import { render } from "./SettlementAdvanceIndex.vue?vue&type=template&id=2242feb9&scoped=true"
import script from "./SettlementAdvanceIndex.vue?vue&type=script&lang=js"
export * from "./SettlementAdvanceIndex.vue?vue&type=script&lang=js"

import "./SettlementAdvanceIndex.vue?vue&type=style&index=0&id=2242feb9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242feb9"]])

export default __exports__